import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { EditRounded } from "@mui/icons-material";
import { AdminToggle, DataTableColumn } from "../../../components/ui";
import { ActiveResponse, SubClassModel } from "../../../services/decisionFlow";

type Options = {
    onToggle: (active: ActiveResponse) => void;
    onEdit: (subclass: SubClassModel) => void;
};

/** Colunas da tabela de subclasses (Subclasse / Status / Ações). */
export function buildSubclassColumns({ onToggle, onEdit }: Options): DataTableColumn<SubClassModel>[] {
    return [
        {
            key: "name",
            header: "Subclasse",
            width: "2fr",
            render: (row) => <Typography sx={{ fontSize: "14px", fontWeight: 500, color: "text.primary" }}>{row.name}</Typography>,
        },
        {
            key: "enabled",
            header: "Status",
            width: "1fr",
            render: (row) => (
                <AdminToggle checked={row.enabled ?? false} onChange={() => onToggle(row)} label={row.enabled ? "Habilitado" : "Desabilitado"} />
            ),
        },
        {
            key: "actions",
            header: "Ações",
            width: "100px",
            align: "right",
            render: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <Tooltip title="Editar" placement="top">
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(row);
                            }}
                            aria-label="Editar"
                            sx={{ borderRadius: "9px" }}
                        >
                            <EditRounded sx={{ fontSize: 16 }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            ),
        },
    ];
}
